<template>
	<div id="feenew">
		<div class="nav">
			<div v-on:click="event_nav_wrong" v-bind:class="{active:nav_type == 'wrong'}">错题</div>
			<div v-on:click="event_nav_collect" v-bind:class="{active:nav_type == 'collect'}">收藏</div>
		</div>
		<div class="moni" v-bind:class="{active:shandong && $app.getParam('subject_type') != 'exam',allhide:!loaded}">
			<div class='questions'>
				<div class="ti_box" v-bind:class="{boxhide:subjectnull}">
					<div class="video_box">
						<video preload="auto" :src="subject.video" controls="controls"></video>
						<div class="gb_box" v-on:click="event_timuUp">
							<span>
								关闭
							</span>
						</div>
						<div class="fg_ht"></div>
					</div>
					<div class='timu-info'>
						<div class="timu" style="overflow:hidden;width:92vw;line-height:8vw;">
							<div style="display:inline-block;font-size: .46rem;">
								{{id_number}}
							</div>
							.
							<span class="timutype">
								{{subject.type_str}}
							</span>
							<div style="display:inline;" v-html="subject.subject"></div>
							<button class="duti" v-bind:class="{active:subject_play_str != '读题'}" v-on:click="event_readsubject">
								<div class="iconfontt icon-maikefeng"></div>
								<span>
									{{subject_play_str}}
								</span>
							</button>
							<button class="video_js" v-on:click="event_timuDown" style="margin-left:0px;">
								<div class="iconfont icon-jiangjie-2"></div>
								<span>
									视频讲解
								</span>
							</button>
						</div>
						<div class='hide rel-pic' v-for="(item_attachment,index) in subject.attachments" v-bind:class="{show:subject.skill_image == '' || !coverskill}">
							<img v-bind:src="item_attachment.image" v-on:click="prediv_image" style="margin:auto;"/>
						</div>
						<div class='rel-pic' v-if="subject.skill_image != '' && coverskill">
							<img v-if="subject.skill_image != '' && coverskill" v-on:click="prediv_image" v-bind:src="subject.skill_image" />
						</div>
						<div class='timu-select'>
							<div v-for="(item,index) in subject.answerList" :key="index" v-on:click='event_subjectCheck(index)' v-bind:class="{checked:item.checked || item.choose}">
								<div v-if="showanswer && item.right || (!item.right && che)" class="iconfontt icon-blank" v-bind:class="{'icon-sure':showanswer && item.right,'icon-wrong':showanswer && !item.right}" style="color:transparent;">
									111
								</div>
								<div style="margin-left:.2rem;" v-if="!showanswer || (showanswer && !item.right && !che)">
									{{letters[index-1]}}：
								</div>
								<div style="font-size:.36rem;">
									<div v-html="item.subject"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="null-box" v-bind:class="{boxhide:!subjectnull}">
					当前没有题目
				</div>
			</div>
			<div class="cover" v-bind:class="{show:jiqiao_show || analysis_show}" v-on:click="event_closecover"></div>
			<div class="jiqiao-box" v-bind:class="{show:jiqiao_show}" id="skillbox" style="top:0vw;margin-top:20vw;">
				<div class='jiqiao-top'>
					<div class='intro'>
						技巧讲解
					</div>
					<span class='replay' v-on:click="event_playjiqiao">
						{{skill_play_str}}
					</span>
				</div>
				<img v-if="subject.skill_image != ''" v-on:click="prediv_image" v-bind:src="subject.skill_image"
				style="max-width:100%;" />
				<div class='jieshao' v-html="subject.skill"></div>
				<div class='guanbi' v-on:click="event_closecover">
					<div class='iconfontt icon-guanbi'></div>
				</div>
			</div>
			<div class="jiqiao-box" v-bind:class="{show:analysis_show}" id="analysisbox"
			style="top:0vw;margin-top:20vw;">
				<div class='jiqiao-top'>
					<div class='intro'>
						帮助
					</div>
					<span class='replay' v-on:click="event_playanalysis">
						{{analysis_play_str}}
					</span>
				</div>
				<div>
					<img v-for="item in subject.analysis_image" v-bind:src="item.image" v-on:click="prediv_image"
					/>
				</div>
				<div class='jieshao'>
					解析：
					<div style="display:inline" v-html="subject.analysis"></div>
				</div>
				<div class='guanbi' v-on:click="event_closecover">
					<div class='iconfontt icon-guanbi'></div>
				</div>
			</div>
			<div class='moni-footer' v-bind:class="{boxhide:subjectnull}">
				<div class="cur" v-on:click="event_subjectPrev">
					<div class="iconfontt icon-arrowleft"></div>
					<span>
						上一题
					</span>
				</div>
				<div class="cur">
					<a>
						<div class="iconfontt icon-menu"></div>
						<span>
							{{id_number}}/{{subjects.length}}
						</span>
					</a>
				</div>
				<div class="cur" open-type="switchTab"
				v-on:click="event_jiqiao">
					<div class="iconfontt icon-huatong"></div>
					<span>
						技巧讲解
					</span>
				</div>
				<div class="cur" open-type="switchTab"
				v-on:click="analysis_show = !analysis_show">
					<div class="iconfontt icon-help"></div>
					<span>
						帮助
					</span>
				</div>
				<div class="cur" open-type="switchTab" v-on:click="event_subjectNext">
					<div class="iconfontt icon-arrowrightt"></div>
					<span>
						下一题
					</span>
				</div>
			</div>
			<div class="voice"></div>
		</div>
	</div>

</template>

<script>
import { Toast , Dialog} from 'we-vue'
let handler = null;
let parent_route = '';
export default {
	name: 'Feenew',
	data () {
		return {
			loaded:false,
			subject: {
				id:0
			},
			subjects:[],
			subject_ids: {},
			subjects_map:{},
			subjects_bd:{},//用来存储已经做过的题目
			voice_src: '',
			jiqiao_show: false,
			analysis_show: false,
			skill_play_str: '播放',
			analysis_play_str: '播放',
			subject_play_str: '读题',
			subjectlog: {},
			shandong: false,
			answer: 0,//当前选中的答案
			showanswer: false,//是否显示答案
			che: false,
			timelimit: 0,
			timeshow: 0,
			time_str: '',
			data_url: '/api/subject3/subject_wrong.html',
			subject_detail_url:'/api/subject3/get_subject_detail.html',
			data_type: 'wrong',
			nav_type:'wrong',
			data_param: {},
			show: false,
			windowHeight: 0,
			windowWidth: 0,
			defaultHeight: 0,
			subjectshow:[],
			coverskill: false,//是否显示技巧图
			letters: ['A', 'B', 'C', 'D', 'E', 'F'],
			collect_loading:false,
			subjectnull:false
		}
	},
	beforeRouteLeave(to, from, next){
		if(to.name == 'Wrong'){
			this.$router.back(-2);
			return false;
		}
		next()
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {})
	},
	computed:{
		id_number(){
			for(var n in this.subjects){
				if(this.subjects[n].id == this.subject.id){
					
					return parseInt(n)+1;
				}
			}
			return '';
		}	
	},
	activated(){
	},
	created (){
		var options = this.$route.query;
		this.parseOptions(options);
		this.loadPage();
	},
	methods:{
		//加载内容
		loadPage(){
			var that = this;
			Toast.loading({
				duration: 30000,
				message: '玩命加载中'
			});
			this.subjects = {};
			this.subjects_bd = {};
			this.$https.post(that.data_url, this.$qs.stringify({
				token:this.$store.state.token,
				data_param: JSON.stringify(that.data_param),
				type: that.data_type
			})).then((res) => {
				Toast.loading({
					duration: 10,
					message: ''
				});
				res.data = res.data.data;
				if(res.data.subject){
					this.subjectnull = false;
					var subjects_map = {};
					var ids = [];
					for(var n in res.data.subjects){
						subjects_map[parseInt(n)+1] = res.data.subjects[n].id;
						ids.push(res.data.subjects[n].id);
					}
					this.subjects = res.data.subjects;
					this.subject = res.data.subject;
					this.setData({
						subject_time: res.data.subject_time,
						subjects_map:subjects_map,
						show: true
					});
					
					this.loadSubject().then((ress) => {
						this.reloadParameter();
						this.loaded = true;
						this.$set(this.subject,'id',res.data.subject.id);
					});
				}else{
					this.loaded = true;
					this.subjectnull = true;
				}
			});
		},
		//重置参数
		reloadParameter(){
			this.help_show = false;
			this.jiqiao_show = false;
			this.skill_play_str = '播放';
			this.analysis_play_str = '播放';
			this.analysis_play_status = '';
			this.subject_play_str = '读题';
			//this.subject = subject;
			this.shandong = false;
			this.answer = 0;
			this.showanswer = false;
			this.coverskill = false;
			this.che = false
			this.$app.audio.stop();
		},
		//加载当前的题目
		loadSubject(){
			var that = this;
			return new Promise((resolve, reject) => {
				try{
					if(that.subject.id){
						//把视频讲解折叠起来
						that.event_timuUp();
						if(typeof that.subjects_bd['subject_'+that.subject.id] != 'undefined'){//如果本地有
							that.subject = that.subjects_bd['subject_'+that.subject.id];
							that.$set(that.subject,'id',that.subjects_bd['subject_'+that.subject.id].id);
							resolve({success:true});
						}else{//否则获取新的
							that.$https.post(that.subject_detail_url, that.$qs.stringify({
								token:that.$store.state.token,
								subject_id: that.subject.id,
								subjectlog_id:that.subjectlog
							})).then((res) => {
								if(res.data.data.id){
									that.parseSubject(res.data.data).then((subject) => {
										that.subject = subject;
										that.subjects_bd['subject_'+subject.id] = subject;
										that.$set(that.subject,'id',subject.id);
										if(subject.subjectlogdetail){
											that.event_subjectCheck({id: subject.subjectlogdetail.answer}, false);
										}
										resolve({success:true});
									});
								}else{
									throw "没有此题目";
								}
							});
						}
					}else{
						throw "当前栏目下没有题目";
					}
				}catch(e){
					Toast.fail({
						duration: 2000,
						message: e
					});
					setTimeout(function(){
						reject({success:false});
						that.$app.goBack();
					},2000);
				}
			});
		},
		inArray(k,arr){
			let i = false
			for(var n in arr){
				if(k == arr[n]){
					i = true
				}
			}
			return i
		},
		parseSubject(subject) {
			var that = this;
			return new Promise((resolve, reject) => {
				//更新答案信息
				var answerList = subject.answer.split(',');
				for (var k in subject.answerList) {
					subject.answerList[k].right = that.inArray(k, answerList);
				}
				resolve(subject);
			});
		},
		setData(params){
			for(var n in params){
				this[n] = params[n]
			}
		},
		audio_right(islastsubject){
			var that = this;
			this.$app.clearAudioEvent('ended');
			this.$app.addAudioEvent('ended',function(){
				if (that.subject.id_number != that.subjects.length) {
					that.event_subjectNext(islastsubject);
				}
			});
			$('audio').attr('src','https://yk.ioccn.com/mp3/2fb0e0980a2d7a1b909c672865be055b.mp3')[0].play();
		},
		parseOptions: function (options) {
		    if (options.nav_type == 'collect') {
				//模拟考试
				this.setData({
					data_url: '/api/subject3/subject_collect.html',
					nav_type: 'collect'
				});
		    } else{
				//必学考题
				this.setData({
					data_url: '/api/subject3/subject_wrong.html',
					nav_type: 'wrong'
				});
		    }
		},
		event_subjectCheck(item, notgo, submit) {
			
		    var answer = typeof item == 'string' ? item : item.id;
		    var che = typeof item == 'string' ? 1 : parseInt(item.che);
		    var that = this;
		    //检测此题是否已经作答，如果已经作答则不继续
		    if (this.subject.subjectlogdetail && notgo !== false) {
				return false;
		    }
		    //如果是多选题则更新答案信息
		    if (this.subject.type == 2 && !this.subject.subjectlogdetail && !this.showanswer && !submit) {
				this.subject.answerList[answer].checked = !this.subject.answerList[answer].checked;
				this.setData({
					subject: this.subject
				});
				return false;
		    }
		    var islastsubject = false;
		    if (this.id_number >= this.subjects.length) {
				islastsubject = true;
		    }

		    //检查答案
		    var response = 'wrong';
		    if (answer == this.subject.answer) {
				response = 'right';
		    }

		    var n = this.id_number - 1;
		    var _answer = answer.indexOf(',') >= 0 ? answer.split(',') : [answer];
		    for (var _n in _answer) {
				this.subject.answerList[_answer[_n]].choose = true;
		    }
			
		    this.subject['subjectlogdetail'] = {
				answer: answer
		    };

			if (response == 'right'){
				this.$app.r('/api/subject3/wrong_delete.html', {
					subject_id: this.subject.id
				}, function (response) { });
		    }

		    //切换到下一题
		    if (notgo !== false) {
				if (response == 'right') {
		      		this.audio_right(islastsubject);
				} else {
					if (this.data_type != 'compensate') {
						if (this.data_type == 'freefee' && this.$store.state.userInfo.user_level_id) {
							this.event_jiqiao();
						}
						this.shandong = true;
					} else {
						this.wrong_number++;
					}
				}
		    }
		    //显示正确错误
		    this.setData({
				answer: this.subject.answer,
				showanswer: true,
				che: che ? true : false
		    });
		},
		event_timuDown () {
			var that = this;
			var res = this.$store.state.userInfo
			if ((res.user_level_id || this.data_type == 'freefee'||res.isreal==1)) { // 判断是否是会员或者免费题目
				var ti_box = document.querySelector(".ti_box")
				var tiVideo = ti_box.querySelector("video")
				ti_box.style.paddingTop = "5.5" + "rem"
				tiVideo.play()
			}else{
				this.$wx.showModal({
					title: '提示',
					content: '无法提供视频讲解服务，请开通会员！',
					success: function (result) {
						if (result.confirm) {
							that.$wx.navigateTo({
								url: '/vip?back=1'
							});
						}
					}
				});
			}
		},
		event_timuUp () {
			var ti_box = document.querySelector(".ti_box")
			var tiVideo = ti_box.querySelector("video")
			ti_box.style.paddingTop = "0" + "rem"
			tiVideo.pause()
		},
		//读题
		event_readsubject(){
			var that = this;
			var res = this.$store.state.userInfo
		    if ((res.user_level_id || this.data_type == 'freefee' || res.isreal == 1)) {
				if (this.subject_play_str == '暂停') {
					this.$app.audio.vplaypause();
					this.subject_play_str = '继续';
				} else if (this.subject_play_str == '继续') {
					//继续播放
					this.$app.audio.vplaypauseplay();
					this.subject_play_str = '暂停';
				} else {
					this.$app.audio.play(this.subject.subject,function(){
						that.subject_play_str = '重播';
					});
					this.subject_play_str = '暂停';
				}
		    } else {
				this.$wx.showModal({
					title: '提示',
					content: '请开通会员！',
					success: function (result) {
						if (result.confirm) {
							that.$wx.navigateTo({
								url: '/vip?back=1'
							});
						}
					}
				});
		    }
		},
		//关闭所有弹出的窗口
		event_closecover(){
			this.setData({
		      analysis_show: false,
		      jiqiao_show: false,
		      skill_play_str: '播放',
		      analysis_play_str: '播放',
		      subject_play_str: '读题',
		    });
		    this.$app.audio.vplaystop();
		},
		//播放技巧
		event_playjiqiao(){
			var that = this;
		    //更换图片
		    if (this.skill_play_str == '暂停') {
				this.setData({
					skill_play_str: '继续',
					shandong: true,
					coverskill: true,
					shandong: true
				});
				this.$app.audio.vplaypause();
		    } else if (this.skill_play_str == '继续') {
				//继续播放
				this.$app.audio.vplaypauseplay();
				this.setData({
					skill_play_str: '暂停',
					shandong: true,
					coverskill: true,
					shandong: true
				});
		    } else {
				this.$app.audio.vplaystop();
				this.setData({
					skill_play_str: '暂停',
					shandong: true,
					coverskill: true,
					shandong: true
				});
		    	this.$app.audio.play(that.subject.skill,function(){
					that.skill_play_str = '重播';
				})
		    }
		},
		//显示技巧
		event_jiqiao(){
			var that = this;
			var res = this.$store.state.userInfo
			if (res.user_level_id || this.data_type == 'freefee' || res.isreal==1) {
				this.jiqiao_show = true;
				this.event_playjiqiao();
			} else {
				this.$wx.showModal({
				  title: '提示',
				  content: '无法提供语音技巧服务，请开通会员！',
				  success: function (result) {
				    if (result.confirm) {
				      //转向到支付
				      that.$wx.navigateTo({
						url: '/vip?back=1'
				      });
				    }
				  }
				});
			}
		},
		prediv_image(){
		
		},
		//播放帮助
		event_playanalysis(){
			var that = this;
		    this.subject_play_str = '读题';
		    var res = this.$store.state.userInfo
		    if (res.user_level_id || this.data_type == 'freefee' || res.isreal==1) {
				if (this.analysis_play_str == '暂停') {
					this.$app.audio.vplaypause();
					this.analysis_play_str = '继续';
				} else if (this.analysis_play_str == '继续') {
					//继续播放
					this.$app.audio.vplaypauseplay();
					this.analysis_play_str = '暂停';
				} else {
					this.$app.audio.vplaystop();
					this.$app.audio.play(this.subject.analysis, function () {
						that.analysis_play_str = '重播';
					})
					this.analysis_play_str = '暂停';
				}
		    } else {
				this.$wx.showModal({
					title: '提示',
					content: '无法提供语音技巧，请购买会员',
					success: function (result) {
						if (result.confirm) {
							that.$wx.navigateTo({
								url: '/vip?back=1'
							});
						}
					}
				});
		    }
		},
		//上一题
		event_subjectPrev(){
			if(this.id_number <= 1){
				this.$wx.showToast({
					title: '这是第一题',
					icon: 'none'
				});
			}else{
				var previd = this.subjects_map[this.id_number-1];
				this.subject.id = previd;
				
				/*this.subject = {
					id:this.subjects_map[this.id_number-1]
				};*/
				this.loadSubject().then((res) => {
					this.reloadParameter();
					this.$set(this.subject,'id',previd);
				});
			}
		},
		//下一题
		event_subjectNext(islastsubject){
			if(this.id_number >= this.subjects.length){
				if(islastsubject !== true){
					this.$wx.showToast({
						title: '这是最后一题',
						icon: 'none'
					});
				}
			}else{
				var nextid = this.subjects_map[this.id_number+1];
				this.subject.id = nextid;
				/*this.subject = {
					id:this.subjects_map[this.id_number+1]
				};*/
				this.loadSubject().then((res) => {
					this.reloadParameter();
					this.$set(this.subject,'id',nextid);
				});
			}
		},
		event_analysis(){
		
		},
		event_nav_collect(){
			this.data_url = '/api/subject3/subject_collect.html'
			this.nav_type = 'collect'
			this.loadPage()
		},
		event_nav_wrong(){
			this.data_url = '/api/subject3/subject_wrong.html'
			this.nav_type = 'wrong'
			this.loadPage()
		},
	},
	mounted () {
		
	}
}

</script>

<style scoped>
.boxhide,.moni-footer.boxhide{
	display:none;
}
.null-box{
	height:auto;
}
.nav{
  height:13vw;
  background-color:#FFFFFF;
  display:flex;
  box-shadow:0px 0px 5px #CCCCCC;
  border-bottom:1px solid #2cd5ff;
}
.nav div{
  flex:1;
  position:relative;
  line-height:13vw;
  text-align:center;
  color:#7D7D7D;
  font-size:16px;
}
.nav div:first-child{
  border-right:1px solid #EEEEEE;
}
.nav div.active{
  background-image:-webkit-gradient(radial, 50% 50%, 250, 50% 50%, 30, from(#FFFFFF), to(#EEEEEE), color-stop(50%, #FFFFFF));
}
.nav div:after{
  content:'';
  width:0px;
}
.nav div.active:after{
  content:'';
  position:absolute;
  width:100%;
  height:5px;
  background-color:#2cd5ff;
  z-index:1;
  bottom:0px;
  left:0px;
}
.nav div.active:before{
  content:'';
  position:absolute;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #f2f2f2;
  background-color:transparent;
  z-index:2;
  bottom:0px;
  left:50%;
}
.allhide{
	visibility: hidden;
}
	.weui-icon-warn{
		color:#9f9f9f;
	}
	#feenew{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.moni{
  position: relative;
  padding-bottom: 70px;
}
.questions{
  background: #fff;
  margin-top:0px;
}
.questions .top{
  display: flex;
  background-color:#0085e4;
  justify-content: space-between;
  align-items: center;
  height:14vw;
  color:#FFFFFF;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
}

.questions .top span{
  font-size: 16px;
}
img{
	max-width:100%;
	max-height:40vw;
	margin:auto;
	display:block;
}

.navigator{
  width:135px;
  text-align:left;
  float:right;
}
.navigator > div{
  padding: 5px 15px;
  display:inline-block;
}
.navigator .timer{
  width:41px;
  padding-right: 5px;
  padding-left:0px;
}
.questions .top button{
  font-size: 16px;
  /*border: 1px solid #2cd5ff;*/
  border-radius: 5px;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding:0px;
  margin:0px;
  background-color:transparent;
  border:0px;
  color:#FFFFFF;
}
.questions .top button.other-navigator-hover{
  background: #e3f9ff;
  color: #2cd5ff;
}
.dati-process{
  width: 100%;
  display:none;
  border-bottom: 1px solid #2cd5ff;
  position: relative
}
.dati-process .process{
  position: absolute;
  left: 0;
  top: 0;
  height: 3px;
  background:#2cd5ff;
}
.timu-info{
  padding: 0 3vw 6vw 3vw;
}
.timu-info .timu{
  margin-top: 10px;
  font-size: 6vw;
  color: #7d7d7d;
  line-height: 24px;
}
.timu-info .timu .timutype{
  border: 1px solid #dedede;
  border-radius: 5px;
  font-size: 4vw;
  color: #666;
  padding: 2px 5px;
  margin:0px 5px;
  display:inline-block;
  width:18vw;
  line-height:5vw;
  text-align:center;
  vertical-align: text-bottom;
}
.timu-info{
	width:100%;
  display:inline-block;
  vertical-align:middle;
  z-index: 10;
  position: relative;
  min-height: 6rem;
  background-color: #fff;
}
.timu-info button{
  border-radius: 10px;
  font-size: 14px;
  display: inline-block;
  margin:0px;
  vertical-align: middle;
  line-height:20px;
  background-color:#ffffff;
}
.timu-info button.duti{
  color: #e60012;
  border: 1px solid #e60012;
  margin-right: 10px;
  display:inline-block;
}
.timu-info button.shoucang{
  color: #eb6100;
  border: 1px solid #eb6100;
  display:inline-block;
}
.timu-info button.shoucang.active{
  background-color:red;
  color:#FFFFFF;
}
.timu-info button div{
  display:inline-block;
}
.rel-pic{
  text-align:center;
  margin-top: 15px;
}
.rel-pic img{
  max-width: 100%;
  max-height:22vh;
}
.timu-select{
  font-size:4vw;
  color:#7D7D7D;
  padding-top:4vw;
}
.timu-select > div{
  width: 100%;
  display: flex;
  min-height: 7.8vw;
  line-height:7.8vw;
  margin-top:5px;
  vertical-align: baseline;
}
.timu-select > div .iconfontt{
  margin-right: 2.5vw;
  margin-top:1vw;
  vertical-align: middle;
  width: 6vw;
  height: 6vw;
  display: inline-block;
}
.moni.active .tixing{
    font-size:20px;
    color: #e60012;
    font-weight: bold;
    -webkit-animation: glow 400ms ease-out infinite alternate !important;
    -moz-animation: glow 400ms ease-out infinite alternate !important;
    -o-animation: glow 400ms ease-out infinite alternate !important;
    -ms-animation: glow 400ms ease-out infinite alternate !important;
    animation: glow 400ms ease-out infinite alternate !important;
}
.timu-select > div .icon-blank{
  background:url(http://jk.ioccn.com/jiakao/Unselected.png) no-repeat;
  background-size:100%;
}
.timu-select > div .icon-sure{
  background:url(http://jk.ioccn.com/jiakao/rightcircle.png) no-repeat;
  background-size:100%;
}
.timu-select > div .icon-wrong{
  background:url(http://jk.ioccn.com/jiakao/error.png) no-repeat;
  background-size:100%;
}
.timu-select > div span{
  font-size: 3vw;
  color: #7d7d7d;
}
.timu-select > div.right span{
  color: #00dd25;
}
.moni-footer{
  position: fixed;
  left: 0;
  bottom:0;
  width: 100%;
  background: #fff;
  display: flex;
  color: #666;
  box-shadow:0 10px 28px -2px #666;
  padding: 1.4vw 0;
  z-index: 99;
}
.moni-footer div{
  flex: 1;
  text-align: center;
}
.moni-footer div span{
  font-size: 12px;
}
.moni-footer .iconfontt{
  width: 20px;
  height: 20px;
  margin:0 auto;
}
.icon-arrowleft{
  background:url(http://jk.ioccn.com/jiakao/arrowleft.png) no-repeat;
}
.icon-huatong{
  background:url(http://jk.ioccn.com/jiakao/huatong.png) no-repeat;
}
.icon-help{
  background:url(http://jk.ioccn.com/jiakao/question.png) no-repeat;
}
.icon-menu{
  background:url(http://jk.ioccn.com/jiakao/menu.png) no-repeat;
}
.icon-arrowrightt{
  background:url(http://jk.ioccn.com/jiakao/arrowright.png) no-repeat;
}

.wxParse-inline,.wxParse-text{
  display:inline;
}

.cover{
    background-color: #000000;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999;
    width: 100%;
    height: 100%;
    display:none;
    opacity: 0.4;
    -webkit-opacity: 0.4;
    -moz-opacity: 0.4;
    -o-opacity: 0.4;
    -ms-opacity: 0.4;
}
.jiqiao-box{
  display:none;
  position:fixed;
  width:80%;
  /* margin-left:-40%; */
  height:auto;
  top:50%!important;
  left:50%;
  z-index:1000;
  background-color:#FFFFFF;
  border:1px solid #CCCCCC;
  padding:5%;
  border-radius:10px;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  margin-top: 0!important;
}
.jiqiao-box img{
  width: 100%;
}
.jiqiao-box .jieshao{
  margin-top: 10px;
  line-height: 30px;
  font-size:4.6vw;
}
.jiqiao-box .guanbi{
  margin-top:20px;
  text-align: center;
  padding-bottom: 10px;
}
.jiqiao-box .guanbi .icon-guanbi{
  font-size: 30px;
  color: #999;
}
.jiqiao-box .jiqiao-top{
position: relative;
padding-bottom: 15px;
text-align: center;
}
.jiqiao-top .intro{
  font-size: 16px;
  color: #434343;
}
.jiqiao-top .replay{
position: absolute;
right: 0;
top: 0;
font-size: 14px;
}
.voice{
  width:100%;
  height:1px;
  overflow:hidden;
}
.show{
  display:block;
}
.timu-select{
  line-height:20px;
}
.moni.hide{
  display:none;
}
.timu-info button.duti.active{
  color:#00dd25;
  border:1px solid #00dd25;
}
.timu-select .checked{
  background-color:#EEEEEE;
}
.jiqiao-box img{
  width: 100%;
}
.jiqiao-box .jieshao{
  margin-top: 10px;
  line-height: 30px;
  font-size:4.6vw;
}
.jiqiao-box .guanbi{
  margin-top:20px;
  text-align: center;
  padding-bottom: 10px;
}
.jiqiao-box .guanbi .icon-guanbi{
  font-size: 30px;
  color: #999;
}
.jiqiao-box .jiqiao-top{
position: relative;
padding-bottom: 15px;
text-align: center;
}
.jiqiao-top .intro{
  font-size: 16px;
  color: #434343;
}
.jiqiao-top .replay{
position: absolute;
right: 0;
top: 0;
font-size: 14px;
}
.voice{
  width:100%;
  height:1px;
  overflow:hidden;
}
.show{
  display:block;
}
.timu-select{
  line-height:20px;
}
.moni.hide{
  display:none;
}
.timu-info button.duti.active{
  color:#00dd25;
  border:1px solid #00dd25;
}
.timu-select .checked{
  background-color:#EEEEEE;
}
.jiqiao-box img{
  display:block;
  margin:auto;
}
.answerhide{
  display:none;
}
.hide{
  display:none;
}
.show{
  display:block;
}
.top{
	font-size:5vw;
}
.timu-info button{
	outline: 0;
}
.timu-info button.video_js{
	color: #2AAFFB;
	border: 1px solid #2AAFFB;
	display: inline-block;
	margin-left: 10px;
  }
  .timu-info button .iconfont {
      font-size: .3rem!important;
  }
  .popup_box{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: none;
  }
  .popup_box .mask{
    background-color: rgba(0,0,0,.2);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .popup_box .popup_video{
    width: 90%;
    padding-bottom: .3rem;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: .1rem;
    overflow: hidden;
  }
  .popup_box .popup_video video{
    width: 100%;
    height: 100%;
  }
  .popup_box .popup_video button{
    width: 90%;
    line-height: .88rem;
    padding: 0;
    display: block;
    border: 0;
    background-color: #2AAFFB;
    font-size: .28rem;
    color: #fff;
    margin-top: .5rem;
  }
  .popup_box .popup_video .guanbi{
    text-align: center;
    margin-top: .6rem;
  }
  .popup_box .popup_video .guanbi .iconfontt{
    font-size: .5rem;
    color: #999;
  }


  .ti_box{
	  /* padding-top: 6.92rem; */
	  position: relative;
	  padding-top: .8rem;
	  transition: all .3s ease-in-out;
  }

  .video_box{
	  width: 100%;
	  height: 5.64rem;
	  position: absolute;
	  top: 0rem;
	  left: 0;
	  background-color: #fff;
  }
  .video_box video{
	  width: 100%;
	  height: 4.2rem;
	  display: block;
  }
  .video_box .gb_box{
	  padding: .2rem .2rem;
  }
  .video_box .gb_box span{
	  font-size: .24rem;
	  color: #fff;
	  background-color: #27BFFF;
	  display: block;
	  text-align: center;
	  line-height: .6rem;
	  border-radius: .1rem;
  }
  .video_box .fg_ht{
	  height: .24rem;
	  background-color: #f1f1f1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Collection.vue